// extracted by mini-css-extract-plugin
export default {"card":"index_card__FYnNA","tag":"index_tag__xEM6W","hidden":"index_hidden__LeKLa","blur-bg":"index_blur-bg__BAZ0x"};